import { EnumTpCalculoModificador } from 'model/enums/enum-tpcalculo-modificador';

export class ModificadorCadastroFormModel {
    constructor(
        public nome: string = '',
        public descricao: string = '',
        public tpCalculo: EnumTpCalculoModificador = EnumTpCalculoModificador.Soma
    ) { }
}